import React from "react"
import PropTypes from "prop-types"
import { connect } from "react-redux"

function Verify({ project, jobType }) {
  return (
    <div>
      <div className='my4'>
        <strong className='mt3'>Verify Drive Content for {project}</strong>
        <p>
          This job requires verifying the {jobType} drive content for {project} {jobType}.
        </p>
      </div>
      <small className='right-align mt3 light block'>
        Ensure the {jobType} drive content is valid before completing this job.
      </small>
    </div>
  )
}

Verify.propTypes = {
  project: PropTypes.string.isRequired,
  jobType: PropTypes.string.isRequired
}

function mapStateToProps(state) {
  return {
    project: state.job.details.project_title
  }
}

function mapDispatchToProps() {
  return {}
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(Verify)
